module.exports = __webpack_public_path__ + "img/background-silver-large.d6f3b590.svg";